// extracted by mini-css-extract-plugin
export default {"modal":"formModal_modal__ew+Un","content":"formModal_content__-+F+l"};